import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models (FN110 + 5 detail tables)
// ============================================================

export interface FN111 {
  fn111_01: string;        // 客訴單號 (FK)
  fn111_02: number;        // 序號
  fn111_11: string;        // 交運單號
  fn111_12: number;        // 交運序號
  fn111_13: string;        // 客戶代號
  fn111_14: number;        // 客訴數量
  fn111_15: string;        // 單位
  fn111_16: number;        // 客訴金額
  fn111_17: string;        // 幣別
  fn111_18: string;        // 布料類別
  fn111_181: string;       // 布料規格1
  fn111_182: string;       // 布料規格2
  fn111_19: number;        // 項次
  fn111_20: string | null; // 交運日期
  fn111_21: string | null; // S/C交期
  fn111_22: string | null; // 出貨日
  fn111_23: number;        // S/C預估毛利
  fn111_24: number;        // 預估毛利率
  fn111_25: number;        // 金額25
  fn111_26: string;        // 狀態26
  fn111_27: string;        // 狀態27
  fn111_90: number;        // 版本號
}

export interface FN112 {
  fn112_01: string;  // 客訴單號 (FK)
  fn112_02: number;  // 序號
  fn112_11: string;  // 客訴代號
  fn112_11a: string; // 客訴說明
  fn112_90: number;  // 版本號
  fn112_12: string;  // 幣別
  fn112_13: number;  // 匯率
  fn112_14: number;  // 金額
}

export interface FN116 {
  fn116_01: string;        // 客訴單號 (FK)
  fn116_02: number;        // 序號
  fn116_11: string;        // 員工代號
  fn116_11a: string;       // 員工姓名
  fn116_12: string | null; // 傳送日期
  fn116_13: string;        // 傳送人
  fn116_14: string | null; // 回覆日期
  fn116_15: string;        // 回覆人
  fn116_16: number;        // 狀態
  fn116_90: number;        // 版本號
  fn116_03: string;        // 留言內容
}

export interface FN117 {
  fn117_01: string;        // 客訴單號 (FK)
  fn117_02: number;        // 序號
  fn117_11: string;        // 附件名稱
  fn117_21: number;        // 檔案類型 (1-5)
  fn117_91: string;        // 修改人
  fn117_92: string | null; // 修改時間
  fn117_93: string;        // 建立人
}

export interface FN111A {
  fn111a_01: string;        // 客訴單號 (FK)
  fn111a_02: number;        // 序號
  fn111a_11: string;        // 交運單號
  fn111a_12: number;        // 抵帳金額
  fn111a_13: string;        // 代號13
  fn111a_12a: number;       // 應收餘額
  fn111a_22: number;        // 金額22
  fn111a_91: string;        // 修改人
  fn111a_92: string | null; // 修改時間
  fn111a_93: string;        // 建立人
}

export interface FN110 {
  fn110_01: string;        // 客訴單號
  fn110_11: string | null; // 入單日期
  fn110_12: string;        // 客戶代號
  fn110_121: string;       // 客戶代號2
  fn110_13: string;        // 建檔人員（舊系統新增時寫 SYS_USER_ID）
  fn110_14: string;        // 幣別
  fn110_15: number;        // 匯率
  fn110_16: number;        // 外幣賠償金額
  fn110_17: number;        // 台幣賠償金額
  fn110_18: number;        // 其他金額
  fn110_19: string;        // 幣別2
  fn110_201: string;       // 幣別3
  fn110_202: number;       // 金額3
  fn110_211: string;       // 幣別4
  fn110_212: number;       // 金額4
  fn110_22: string;        // 部門代號（核准權限依據）
  fn110_23: number;        // 狀況代碼
  fn110_28: string;        // 備註
  fn110_29: boolean;       // 訂單取消模式
  fn110_30: string;        // S/C NO
  fn110_31: string;        // 客訴說明
  fn110_32: number;        // 交運明細項數
  fn110_33: number;        // 處理要求項數
  fn110_34: number;        // 整數34
  fn110_35: number;        // 整數35
  fn110_36: number;        // 留言明細項數
  fn110_37: number;        // 附件明細項數
  fn110_38: number;        // 抵帳明細項數
  fn110_71: string;        // 處理狀況71
  fn110_72: string;        // 處理狀況72
  fn110_73: string;        // 處理狀況73
  fn110_74: string;        // 處理狀況74
  fn110_75: string;        // 處理狀況75
  fn110_80: string;        // 狀態 (N/P)
  fn110_801: string;       // 業務核准
  fn110_8011: string;      // 業務核准備忘
  fn110_802: string;       // 採購核准
  fn110_8021: string;      // 採購核准備忘
  fn110_803: boolean;      // 轉採購段
  fn110_81: string;        // 狀態81
  fn110_82: string;        // 狀態82
  fn110_83: string;        // 狀態83
  fn110_84: string;        // 狀態84
  fn110_841: string;       // 備忘841
  fn110_842: string | null;// 日期842
  fn110_85: string;        // 狀態85
  fn110_851: string;       // 備忘851
  fn110_852: string | null;// 日期852
  fn110_131: string;       // 業務人員
  fn110_132: string;       // 業務人員2
  fn110_134: string;       // 業務人員4
  fn110_221: string;       // 客訴狀況221
  fn110_90: number;        // 版本號
  fn110_91: string;        // 修改人
  fn110_92: string | null; // 修改時間
  fn110_93: string;        // 建立人
  fn110_94: string;        // 狀態94
  // Associations
  ship_details?: FN111[];
  handle_details?: FN112[];
  messages?: FN116[];
  attachments?: FN117[];
  offset_details?: FN111A[];
}

export interface CreateRequest {
  master: FN110;
  ship_details: FN111[];
  handle_details: FN112[];
  messages: FN116[];
  attachments: FN117[];
  offset_details: FN111A[];
}

export interface UpdateRequest {
  master: FN110;
  ship_details: FN111[];
  handle_details: FN112[];
  messages: FN116[];
  attachments: FN117[];
  offset_details: FN111A[];
}

export interface ListResponse {
  data: FN110[];
  total: number;
  page: number;
  pageSize: number;
}

export interface ValidationError {
  field: string;
  message: string;
}

export interface ApproveResponse {
  fn110_01: string;
  fn110_80: string;
}

export interface InvoiceRequestResponse {
  fn110_01: string;
  invoice_requests: string[];
}

// ============================================================
// API Functions
// ============================================================

const BASE = '/api/pwn201';

export const pwn201Api = {
  async list(page = 1, pageSize = 20): Promise<ListResponse> {
    const res = await apiClient.get<ListResponse>(BASE, { params: { page, pageSize } });
    return res.data;
  },

  async get(id: string): Promise<FN110> {
    const res = await apiClient.get<FN110>(`${BASE}/${encodeURIComponent(id)}`);
    return res.data;
  },

  async create(req: CreateRequest): Promise<FN110> {
    const res = await apiClient.post<FN110>(BASE, req);
    return res.data;
  },

  async update(id: string, req: UpdateRequest): Promise<FN110> {
    const res = await apiClient.put<FN110>(`${BASE}/${encodeURIComponent(id)}`, req);
    return res.data;
  },

  async delete(id: string): Promise<void> {
    await apiClient.delete(`${BASE}/${encodeURIComponent(id)}`);
  },

  // POST /api/pwn201/:id/approve (Command2.Click — 業務自核).
  // confirmed:true mirrors the Popconfirm the caller already went through in
  // PWN201Form (FoxPro's PWU016F2 "請確認核准本資料!" dialog); the backend
  // requires it (see backend/modules/pwn201/models/pwn201.go ApproveRequest).
  async approve(id: string): Promise<ApproveResponse> {
    const res = await apiClient.post<ApproveResponse>(`${BASE}/${encodeURIComponent(id)}/approve`, { confirmed: true });
    return res.data;
  },

  // Dedicated PgId 20102 action replacing FoxPro's hard-coded employee 0262
  // visibility gate. Authorization remains server-side; the UI permission is
  // only a visibility mirror.
  async createInvoiceRequests(id: string): Promise<InvoiceRequestResponse> {
    const res = await apiClient.post<InvoiceRequestResponse>(
      `/api/pwn201-invoice-request/${encodeURIComponent(id)}`,
      { confirmed: true },
    );
    return res.data;
  },
};

export default pwn201Api;
